export default __webpack_public_path__ + "static/pragicts-secops-services-mtiaas-dbb0e02d4d396afe40c6ce298d9865f6.jpg";